module.exports = __webpack_public_path__ + "static/media/593JamesPBrawleyDrNW_2018-06-12_106.b1ee989a.jpg";